import { axiosInstance } from "@/api/apiClient";
import {
  InternationalPurchaseApi,
  InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest,
  InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";
import { CustomAxiosRequestConfig } from "../types";

const api = new InternationalPurchaseApi(undefined, BASE_API, axiosInstance);

export const purchaseAuthInternationalNumber = async (
  payload: InternationalPurchaseApiPaymentsViewsNinjaPurchaseAuthInternationalNumberPurchaseRequest
) => {
  return api.paymentsViewsNinjaPurchaseAuthInternationalNumberPurchase.bind(
    api
  )(payload);
};

export const purchaseInternationalNumber = async (
  payload: InternationalPurchaseApiPaymentsViewsNinjaPurchaseInternationalNumberPurchaseRequest
) => {
  return api.paymentsViewsNinjaPurchaseInternationalNumberPurchase.bind(api)(
    payload,
    {
      accessLevel: "public",
    } as CustomAxiosRequestConfig
  );
};
